import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from 'src/app/core/services/request/request.service';
import {Utilidades} from '../../../../core/utils/utildades';

@Component({
    selector: 'app-detalleSolicitud',
    templateUrl: './detalleSolicitudMulti.component.html',
    styleUrls: ['./detalleSolicitudMulti.component.scss'],
    standalone: false
})
export class DetalleSolicitudMultiComponent implements OnInit {

  constructor(public requestService: RequestService, private route: ActivatedRoute) {}

  solicitudDetalle: any = null;
  solicitudId = '';
  complementosAgrupados: { [tipo: string]: { parentesco: string; numeroDocumento: string; nombre: string; fechaActualizacion: string; estado: string }[] } = {};

  ngOnInit(): void {
    this.solicitudId = this.route.snapshot.paramMap.get('id');
    this.obtenerDetalle();
  }

  obtenerDetalle(): void {
    this.requestService.obtenerDetalleSolicitud(this.solicitudId).subscribe({
      next: (data) => {
        this.solicitudDetalle = data;
        this.agruparPorComplementos();
      },
      error: (error) => {
        console.error('Error al obtener el detalle:', error);
      }
    });
  }

  agruparPorComplementos() {
    if (!this.solicitudDetalle) {
      console.warn("solicitudDetalle no está definida.");
      return;
    }

    this.complementosAgrupados = {};

    if (this.solicitudDetalle.titular?.complementos) {
      this.solicitudDetalle.titular.complementos.forEach(complemento => {
        const key = complemento.tipo;
        if (!this.complementosAgrupados[key]) {
          this.complementosAgrupados[key] = [];
        }
        this.complementosAgrupados[key].push({
          parentesco: "Titular",
          numeroDocumento: this.solicitudDetalle.numeroIdentidadTitular,
          nombre: `${this.solicitudDetalle.titular.primerNombre || ''} ${this.solicitudDetalle.titular.primerApellido || ''}`,
          fechaActualizacion: complemento.actualizacion,
          estado: complemento.estado
        });
      });
    }

    if (this.solicitudDetalle.beneficiarios?.length) {
      this.solicitudDetalle.beneficiarios.forEach(beneficiario => {
        if (beneficiario.complementos?.length) {
          beneficiario.complementos.forEach(complemento => {
            const key = complemento.tipo;
            if (!this.complementosAgrupados[key]) {
              this.complementosAgrupados[key] = [];
            }
            this.complementosAgrupados[key].push({
              parentesco: beneficiario.parentesco || 'N/A',
              numeroDocumento: beneficiario.numeroDocumento || 'N/A',
              nombre: `${beneficiario.primerNombre || ''} ${beneficiario.primerApellido || ''}`,
              fechaActualizacion: complemento.actualizacion,
              estado: complemento.estado || 'N/A'
            });
          });
        }
      });
    }
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }
  obtenerNombreEstado(codigoEstado: string): string {
    return Utilidades.clasificarEstado(codigoEstado);
  }
}
